/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

import { AUTH_ROLES } from '@/constants/roles.constant';
import { ROUTES } from '@/constants/routes.constant';

/**
 * Export.
 */
export default [
  {
    beforeEnter: () => {
      window.location.href = `/apps/partner/external-applications${window.location.search}`;
    },
    component: () =>
      import(

        /* webpackChunkName: "partner" */
        '@/modules/external/scenes/external-applications/external-applications.scene.vue'
      ),
    meta: { requiresAuth: true, roles: [AUTH_ROLES.PARTNERSHIP_SIS] },
    name: ROUTES.EXTERNAL.EXTERNAL_APPLICATIONS,
    path: 'partner/external/applications/:code?'
  }
] as RouteConfig[];
